/**
 * Generato automaticamente.
 * framework-cfg-utenti
 */

export type EnumPersonaGiuridicaDTOStatoAccreditamento =
  (typeof EnumPersonaGiuridicaDTOStatoAccreditamento)[keyof typeof EnumPersonaGiuridicaDTOStatoAccreditamento];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumPersonaGiuridicaDTOStatoAccreditamento = {
  BOZZA: 'BOZZA',
  VALIDATA: 'VALIDATA',
  REVOCATA: 'REVOCATA',
} as const;
